<div class="btn-import-advanced" (click)="toggleImporter()"></div>
<div *ngIf="expanded" class="importer">
    <div class="importer-header">
        <h2>Advanced Import</h2>
        <div class="close" (click)="toggleImporter()"></div>
    </div>

    <div class="importer-body">
        <p>Import your data easily with our advanced importer.</p>

        <input #importinput class="invisible" type="file" name="importinput" (change)="onImportFileChange($event)" />
        <button (click)="importinput.click()">Select File to Import</button>

    </div>

  <!-- {{itemType}} -->
</div>